/**
 * Constrain a value by clamping it within the specified range.
 * If `isCyclic` is true, the value will wrap around when it exceeds the bounds.
 */
export function constrainValue(
  value: number | null,
  minValue?: number,
  maxValue?: number,
  isCyclic: boolean = false,
): number | null {
  if (value === null) {
    return value;
  }

  if (minValue !== undefined && value < minValue) {
    return isCyclic ? maxValue ?? minValue : minValue;
  }

  if (maxValue !== undefined && value > maxValue) {
    return isCyclic ? minValue ?? maxValue : maxValue;
  }

  return value;
}
